import { FVEnviroment } from '../../models/enviroment';

export class Debugger {
  protected enviroment: FVEnviroment;
  protected showDebug: boolean;

  constructor() { }

  protected init(enviroment: FVEnviroment) {
    this.enviroment = enviroment;
    this.showDebug = enviroment.debug;
  }

  protected log(...messages) {
    this.action('log', ...messages);
  }

  protected warn(...messages) {
    this.action('warn', ...messages);
  }

  protected error(...messages) {
    this.action('error', ...messages);
  }

  protected info(...messages) {
    this.action('info', ...messages);
  }

  protected debug(...messages) {
    this.action('debug', ...messages);
  }

  private action(method: string, ...messages) {
    if (this.showDebug) {
      console[method](...messages);
    }
  }
}
